









































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ModalRegraTeto extends Vue {
  menuInicioVigencia = false
  menuFimVigencia = false
  loadAddRegraCalculo = false

  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  get showModal() {
    return this.getRegrasDeCalculoStore.modal.regraDeTeto
  }
  set showModal(value: boolean) {
    this.getRegrasDeCalculoStore.setModal({ name: 'regraDeTeto', value })
  }

  get mode() {
    return this.getRegrasDeCalculoStore.mode
  }

  get fontesPagadoras() {
    return this.getRegrasDeCalculoStore.fontesPagadoras
  }

  get prestadores() {
    return this.getRegrasDeCalculoStore.prestadoresRepasse
  }

  get hospitais() {
    return this.getRegrasDeCalculoStore.fontesPagadoras
  }

  get valorReferenciaTeto() {
    return this.getRegrasDeCalculoStore.valorReferenciaTeto
  }

  get tipoProducao() {
    return this.getRegrasDeCalculoStore.tipoProducao
  }

  get getMenuInicioVigencia() {
    return this.menuInicioVigencia
  }
  set getMenuInicioVigencia(value: boolean) {
    this.menuInicioVigencia = value
  }

  get getMenuFimVigencia() {
    return this.menuFimVigencia
  }
  set getMenuFimVigencia(value: boolean) {
    this.menuFimVigencia = value
  }

  get loadingAddRegraCalculo() {
    return this.loadAddRegraCalculo
  }
  set loadingAddRegraCalculo(value: boolean) {
    this.loadAddRegraCalculo = value
  }

  formatDate(vigencia: any) {
    const date = new Date(vigencia)
    if (!Number.isNaN(date.getTime())) {
      const day = String(date.getUTCDate()).padStart(2, '0')
      const month = String(date.getUTCMonth() + 1).padStart(2, '0')
      const year = date.getUTCFullYear()
      return `${day}/${month}/${year}`
    }
    return ''
  }

  get formattedInicioVigencia() {
    const { vigenciaInicio } = this.getRegrasDeCalculoStore.regraTetoItem
    return vigenciaInicio ? this.formatDate(vigenciaInicio) : ''
  }

  get formattedFimVigencia() {
    const { vigenciaFim } = this.getRegrasDeCalculoStore.regraTetoItem
    return vigenciaFim ? this.formatDate(vigenciaFim) : ''
  }

  async addValorFixo() {
    this.loadingAddRegraCalculo = true
    const paginacaoAtual = this.getRegrasDeCalculoStore.paginacaoRegrasValorFixo

    const request = await this.getRegrasDeCalculoStore.addRegraTeto()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Procedimento incluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculo = false
    this.getRegrasDeCalculoStore.getRegraTeto(paginacaoAtual)
    this.showModal = false
  }

  mounted() {
    this.getRegrasDeCalculoStore.getValorReferenciaTeto()
    this.getRegrasDeCalculoStore.getTipoProducao()
  }

  mapItems() {
    const item = this.getRegrasDeCalculoStore.regraTetoItem

    if (item && Array.isArray(item.tipoProducao)) {
      item.tipoProducao = item.tipoProducao.map(tp => tp && tp.key ? tp.key : tp)
    }

    if (item && Array.isArray(item.hospitaisId)) {
      item.hospitaisId = item.hospitaisId.map(h => h && h.id ? h.id : h)
    }
  }

  @Watch('showModal')
  onShowModalChange(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.clearRegraTeto()
      return
    }

    this.mapItems()
  }
}
